/*------------------------------------------------
// File Name:PDM_MA_Path.js
// File Description:PDM_MA_Path API方法js接口
// Author:zxl
// Create Time:2023/07/11 16:27:07
//------------------------------------------------*/
import { axios } from '@/utils/request'

const api = {
   _maPath: "/PDM_MA_Path"
}

export default api


//-------------------创建康复预约文件存储对象-------------------
export function CreatePDM_MA_PathEntity(parameter) {
    return axios({
        url: api._maPath + "/CreatePDM_MA_PathEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------获取康复预约文件存储列表-------------------
export function GetPDM_MA_PathList(parameter) {
    return axios({
        url: api._maPath + "/GetPDM_MA_PathList",
        method: 'post',
        data: parameter
    })
}

//-------------------分页获取康复预约文件存储列表---------------
export function GetPDM_MA_PathListByPage(parameter) {
    return axios({
        url: api._maPath + "/GetPDM_MA_PathListByPage",
        method: 'post',
        data: parameter
    })
}

//-------------------获取康复预约文件存储对象---------------
export function GetPDM_MA_PathEntity(parameter) {
    return axios({
        url: api._maPath + "/GetPDM_MA_PathEntity",
        method: 'post',
        data: parameter
    })
}


//-------------------保存康复预约文件存储对象---------------
export function UpdatePDM_MA_PathEntity(parameter) {
    return axios({
        url: api._maPath+ "/UpdatePDM_MA_PathEntity",
        method: 'post',
        data: parameter
    })
}

//-------------------删掉康复预约文件存储对象---------------
export function DeletePDM_MA_PathEntity(parameter) {
    return axios({
        url: api._maPath + "/DeletePDM_MA_PathEntity",
        method: 'post',
        data: parameter
    })
}
